import React from 'react';
import styles from './styles';

import { Content, Header, Text } from '../../components/common';

function arrayToBulletPoints(array) {
  return array.map(item => `•   ${item}`).join('\n\n');
}

export const dsrFaqHeaders = [
  'What is Demand Side Response?',
  'How does my Halo support Demand Side Response?',
  'What is a Type Of Use?',
  'What is Dynamic Control?',
  'How does Dynamic Control Demand Side Response work?',
  'Can I cancel a Demand Side Response program?',
  'How do I opt in to Demand Side Response?',
  'Can I opt out of Demand Side Response?',
  'What information do you share with my energy supplier/home energy management system?',
  'What happens if I’m already in Override mode?',
  'What happens if my Halo is in Holiday mode or Off?',
  'Why doesn’t my smart speaker work when a DSR programme is active?',
];

const dsrFaqAnswers = [
  'This is the name given to various services that encourages us to change our energy demand habits. This could be anything from understanding when energy consumption from the grid is “greener”, rewards for not using energy at peak times or allowing your energy supplier to choose more eco-friendly times for your appliances to operate.',

  'Broadly speaking, your Halo can support two types of Demand Side Response.\n\n' +
    arrayToBulletPoints(['Type of Use', 'Dynamic Control']) +
    '\n\nYou will need to sign up to a compatible tariff with your energy provider to enable either of these supported services.',

  'A Type Of Use Tariff normally offers a preferential price of energy based on which appliance in your home uses that energy. For example, the energy used by your heat pump could be charged at a preferential rate to the energy that your other appliances (washing machine, fridge, lights) use.',

  'A Dynamic Control Tariff enables your energy supplier to manage your appliances in a way that eases the demand on the grid, meaning renewable energy use can be maximised and more carbon intensive energy use can be minimised.',

  'Demand Side Response (DSR) works by allowing your energy supplier, or home energy management system, to adjust your heating target temperature for a period of time. This either helps to reduce the total demand on the electricity grid or can utilise surplus energy available, potentially from renewable sources.',

  'Yes, if you wish to you can cancel an active DSR program. This could have a financial impact so it’s best to check with your energy provider before you cancel a DSR program.',

  'To sign up to Demand Side Response, speak to your energy provider to find out what they can offer.',

  'Yes, you can opt out. However, your energy tariff may be reliant on having an active demand side response connection and opting out of this may have a financial impact. Be sure to check with your energy provider before opting out.',

  'To link your Halo account with your energy provider we will need to share your:\n\n' +
    arrayToBulletPoints(['Account Id', 'First & last name', 'Email address']) +
    '\n\n\nTo support Demand Side Response, we share the following information with your energy provider or home energy management system:\n\n' +
    arrayToBulletPoints([
      'Device Id',
      'Zone number',
      'Current operating mode',
      'Heating target temperature',
      'Comfort temperature setpoint',
      'Setback temperature setpoint',
      'Current room temperature',
      'Holiday Mode',
      'Heating schedule',
      'Hot water Output Temperature',
      'Compressor modulation',
      'Return temperature',
      'Flow temperature',
      'Number of Successful Compressor Starts',
      'Number of operation hours of the Compressor',
      'Number of Hot water Immersion, or back up heater, starts',
      'Number of running Hours of Hot water Immersion, or back up heater',
      'Primary flow Rate',
      'Position of the diverter valve',
      'Cascade header temperature',
      'Overall Heat Pump state',
      'Heating circuit 1 state',
      'Hot water mode',
    ]),

  'If you have set your Halo to Override mode and your energy supplier wants to apply a DSR program you will receive a push notification from your Halo app asking if you wish to accept the DSR program or not. If you do not wish to accept the DSR program simply reject the request via the notification in the Halo app.',

  'If you have set Halo to holiday mode or Off, no DSR programs will be applied during this time.',

  'Currently there is no support for DSR via Google or Alexa. When your DSR programme is complete smart speaker functionality will resume.',
];

function Faq({ question, answer }) {
  return (
    <Content>
      <Header title="Demand Side Response" subText="Support & FAQs" />

      <Content
        isInnerContent
        scrollable
        enableScrollShadow
        style={styles.faqTextContainer}>
        <Text size="sm" weight="bold">
          {[question, '\n']}
        </Text>

        <Text size="sm">{answer}</Text>
      </Content>
    </Content>
  );
}

export default dsrFaqHeaders.map((header, index) => ({ props }) => {
  return Faq({ question: header, answer: dsrFaqAnswers[index], ...props });
});
